import { Toast } from "@base-ui/react/toast";
import { Tooltip } from "@base-ui/react/tooltip";
import { useState } from "react";
import { ToastViewport, toastManager } from "../primitives/toast/toast";
import { PortalHostContext } from "./portal-host";
import { type Theme, ThemeProvider } from "./theme-provider";

export interface AssetWatchUiProviderProps {
  children: React.ReactNode;
  defaultTheme?: Theme;
  storageKey?: string;
}

/**
 * Root provider for @assetwatch/ui. Wraps ThemeProvider with Tooltip.Provider
 * for snappy multi-tooltip behavior (zero delay when hovering between tooltips)and Toast.Provider with
 * a shared ToastViewport for app-wide toast notifications.
 */
function AssetWatchUiProvider({
  children,
  defaultTheme,
  storageKey,
}: AssetWatchUiProviderProps) {
  const [portalHost, setPortalHost] = useState<HTMLDivElement | null>(null);
  const [blockingLayerHost, setBlockingLayerHost] =
    useState<HTMLDivElement | null>(null);

  return (
    <PortalHostContext value={{ blockingLayerHost, portalHost }}>
      <Tooltip.Provider delay={300} timeout={400}>
        <Toast.Provider toastManager={toastManager} timeout={5000} limit={1}>
          <ThemeProvider defaultTheme={defaultTheme} storageKey={storageKey}>
            {children}
            <div data-slot="assetwatch-ui-portal-host" ref={setPortalHost} />
            <div
              data-slot="assetwatch-ui-blocking-layer-host"
              ref={setBlockingLayerHost}
            />
            <ToastViewport />
          </ThemeProvider>
        </Toast.Provider>
      </Tooltip.Provider>
    </PortalHostContext>
  );
}

export { AssetWatchUiProvider };
